(function() { module.exports = window["VueI18n"]; }());